import moment from 'moment';


export default function ExaminedByDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  bcpDataService
) {
  const vm = this;

  vm.examineDateMinDate = moment().add(
    -180,
    'days'
  );
  vm.examineCurrentDate = moment().add(
    0,
    'days'
  );
  vm.examineDateMaxDate = vm.examineCurrentDate;
  vm.confirmSubmit = false;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSaveExaminedBy = _handleSaveExaminedBy;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    vm.examineDate = moment(
      vm.examineCurrentDate
    ).format('MM/DD/YYYY');
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.examinedByDialog);
  }

  function _handleSaveExaminedBy() {
    const dfdSave = $q.defer();

    if ($scope.bcpExaminedByForm.$valid) {
      bcpDataService.examinedBy(
        vm.assessmentId,
        vm.examinedBy,
        vm.examineDate
      ).then((response) => {
        if (!response.data.result) {
          alerts.error('Error occurred while saving Process / Document Examined By.');
        } else {
          alerts.success(
            'The BCP assessment Process/ Document Examined by is saved successfully.'
          );
          $rootScope.$broadcast('refreshBCPAssessments');
          ssDialogService.hide(ssDialogService.dialogs.bcp.examinedByDialog);
        }
        dfdSave.resolve();
      });
    } else {
      dfdSave.reject();
    }
  }
}

ExaminedByDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'ssDialogService',
  'bcpDataService'
];
